export default __webpack_public_path__ + "static/media/unicorn.3494e811.svg";